import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import styles from './LeftColumnWrapper.scss';

export default function LeftColumnWrapper({ children, withSubmenu }) {
    const className = withSubmenu ? 'left-column-with-submenu' : 'left-column';

    return (
        <section data-section="left-column" className={styles[className]}>
            {children}
        </section>
    );
}

LeftColumnWrapper.displayName = displayName('LeftHandNav/LeftColumnWrapper');

LeftColumnWrapper.propTypes = {
    children: PropTypes.any,
    withSubmenu: PropTypes.bool,
};

LeftColumnWrapper.defaultProps = {
    withSubmenu: true,
    children: null,
};
